import React, { useState, useEffect } from 'react';
import moment from "moment";
import { useAuth } from '../../Common/Configurations/AuthContext';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import ModifyFlightSearch from './ModifyFlightSearch';
import DefaultData from '../../CompanyData/DefaultData';
const Flights = () => {
    const { currencies } = useAuth();
    const params = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [pageLoading, setPageLoading] = useState(false);
    const [currency, setCurrency] = useState(DefaultData?.DEFAULTCURRENCY);
    const [flightData, setFlightData] = useState([]);
    const [searchQuery, setSearchQuery] = useState({});
    const [activeTab, setActiveTab] = useState(0);
    const [expandedFlights, setExpandedFlights] = useState({}); // Track which flights have fares expanded
    const [selectedFares, setSelectedFares] = useState({}); // Track selected fare per flight
    const handleCurrencyChange = (newCurrency) => {
        setCurrency(newCurrency);
    };
    /* List Start */
    const [filters, setFilters] = useState({
        airlines: [],
        priceRange: [0, 9999999],
        departureTime: '',
        stops: []
    });
    const getAirlines = () => {
        const set = new Set();
        flightData.forEach(tab =>
            tab.dcFlightLegs.forEach(flight => set.add(flight.dcDisplayLegs[0]?.airlineData?.airline))
        );
        return Array.from(set);
    };
    const handleFilterChange = (type, value) => {
        setFilters(prev => {
            if (type === 'airlines' || type === 'stops') {
                const updated = prev[type].includes(value)
                    ? prev[type].filter(v => v !== value)
                    : [...prev[type], value];
                return { ...prev, [type]: updated };
            } else if (type === 'priceRange') {
                return { ...prev, priceRange: value };
            } else {
                return { ...prev, [type]: value };
            }
        });
    };
    const applyFilters = (flights) => {
        return flights.filter(flight => {
            const displayLeg = flight.dcDisplayLegs[0];
            const airline = displayLeg?.airlineData?.airline;
            const stops = displayLeg?.stops;
            const price = flight.totalPrice || 0;
            const departureHour = new Date(displayLeg?.startSegment.departureDateTime).getHours();

            return (
                (filters.airlines.length === 0 || filters.airlines.includes(airline)) &&
                (filters.stops.length === 0 || filters.stops.includes(stops)) &&
                (price >= filters.priceRange[0] && price <= filters.priceRange[1]) &&
                (
                    !filters.departureTime ||
                    (filters.departureTime === "morning" && departureHour >= 5 && departureHour < 12) ||
                    (filters.departureTime === "afternoon" && departureHour >= 12 && departureHour < 17) ||
                    (filters.departureTime === "evening" && departureHour >= 17 && departureHour < 21) ||
                    (filters.departureTime === "night" && (departureHour >= 21 || departureHour < 5))
                ));
        });
    };
    const handleClearFilters = () => {
        setFilters({
            airlines: [],
            priceRange: [0, 9999999],
            departureTime: "",
            stops: []
        });
    };
    function getTimeFromMins(mins) {
        var h = mins / 60 | 0, m = mins % 60 | 0;
        var durationformat = h + "h " + m + "m";
        return durationformat;
    }
    const handleToggleFares = (supplierLegId) => {
        setExpandedFlights(prev => ({ ...prev, [supplierLegId]: !prev[supplierLegId] }));
    };
    const handleSelectFare = (journeyType, flightLeg, selectedSupplierPriceId) => {
        const selectedFare = flightLeg.dcPriceDetails.find(
            (fare) => fare.supplierPriceId === selectedSupplierPriceId
        );

        if (selectedFare) {
            setSelectedFares((prev) => ({
                ...prev,
                [journeyType]: {
                    flightLeg,
                    fare: selectedFare
                }
            }));
        }
    };

    const BindPageData = (searchQuery) => {
        setPageLoading(true)
        GetFlights(searchQuery);
    }
    const GetFlights = async (searchQuery) => {
        var result = await apiService.post(config.SEARCHFLIGHTS, searchQuery);
        if (result.length > 0) {
            const defaultSelected = {};
            const sortedData = result.map((destination) => {
                const sortedLegs = [...destination.dcFlightLegs].sort(
                    (a, b) => a.totalPrice - b.totalPrice
                );

                const cheapestLeg = sortedLegs[0];
                let matchingFare = null;

                if (cheapestLeg?.dcPriceDetails?.length > 0) {
                    matchingFare = [...cheapestLeg.dcPriceDetails].sort(
                        (a, b) => a.totalPrice - b.totalPrice
                    )[0];
                }

                if (cheapestLeg && matchingFare) {
                    defaultSelected[destination.journeyType] = {
                        flightLeg: cheapestLeg,
                        fare: matchingFare
                    };
                }

                return {
                    ...destination,
                    dcFlightLegs: sortedLegs
                };
            });

            setFlightData(sortedData);
            setSelectedFares(defaultSelected);
        }
        else {
            alert("No flights found")
        }
        setPageLoading(false);

    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = Object.values(selectedFares).map(({ flightLeg, fare }) => ({
            flightLeg: flightLeg,
            fare: fare
        }));
        console.log("Submit to API:", payload);
        navigate('/flightdetails/' + params.adults + "/" + params.kids + "/" + params.infants + "/" + params.isDomestic, { state: { searchQuery, payload } });
    };
    const handleSearch = (query) => {
        setSearchQuery(query);
        setPageLoading(true);
        BindPageData(query);
    };
    useEffect(() => {
        if (state === null) {
            navigate('/flight/search')
        }
        else if (params === null) {
            navigate('/flight/search')
        }
        else if (state.searchQuery === null) {
            navigate('/flight/search')
        }
        else {
            setSearchQuery(state.searchQuery);
            setPageLoading(true);
            BindPageData(state.searchQuery);
        }
        if (currencies?.length > 0) {
            const userCurrency = DefaultData?.DEFAULTCURRENCY || 'INR';
            const defaultCurrency = currencies.find(c => c.code === userCurrency);
            setCurrency(defaultCurrency);
        }
    }, []);
    return (
        <>
            <div className="container-fluid">
                {/* start page title */}
                <div className="card">
                    <ModifyFlightSearch onSearch={handleSearch}></ModifyFlightSearch>
                </div>
                <div className="row">
                    <div className="col-3">
                        <div className="card">
                            <div className="card-header">
                                <div className="d-flex mb-0">
                                    <div className="flex-grow-1">
                                        <h5 className="fs-16">Filters</h5>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <Link onClick={handleClearFilters} className="text-decoration-underline">Clear All</Link>
                                    </div>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div style={{ marginTop: '10px' }}>
                                    <p className="text-muted text-uppercase fs-12 fw-medium mb-2">Stops</p>
                                    {[0, 1, 2].map(stop => (
                                        <div key={stop}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={filters.stops.includes(stop)}
                                                    onChange={() => handleFilterChange('stops', stop)}
                                                />
                                                {stop} Stop{stop !== 1 ? 's' : ''}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    <p className="text-muted text-uppercase fs-12 fw-medium mb-2">Departure Time</p>
                                    {["morning", "afternoon", "evening", "night"].map(slot => (
                                        <div key={slot}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <input
                                                    type="radio"
                                                    name="departureTime"
                                                    checked={filters.departureTime === slot}
                                                    onChange={() => handleFilterChange('departureTime', slot)}
                                                />
                                                {slot.charAt(0).toUpperCase() + slot.slice(1)}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    <p className="text-muted text-uppercase fs-12 fw-medium mb-2">Price Range</p>
                                    <input
                                        type="range"
                                        min={0}
                                        max={9999999}
                                        value={filters.priceRange[1]}
                                        onChange={(e) =>
                                            handleFilterChange('priceRange', [0, parseInt(e.target.value)])
                                        }
                                    />
                                    <div>Up to INR {filters.priceRange[1]}</div>
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    <p className="text-muted text-uppercase fs-12 fw-medium mb-2">Airlines</p>
                                    {getAirlines().map((airline, idx) => (
                                        <div key={idx}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={filters.airlines.includes(airline)}
                                                    onChange={() => handleFilterChange('airlines', airline)}
                                                />
                                                {airline}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {/* end card */}
                    </div>
                    {pageLoading === true ?
                        <div className='col-9'>
                            <div className="card">
                                <div className="card-body">
                                    <div className='text-center'>
                                        <img src="/assets/images/loader.webp" width={"64px"} height={"64px"}></img>
                                        Loading, Please wait...</div>
                                </div>
                            </div> </div> :
                        <div className='col-9'>
                            <div className="card">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-md-12">
                                            <ul className="nav nav-pills arrow-navtabs nav-success card-header-tabs border-bottom-0" role="tablist">
                                                {flightData.length > 0 && flightData.map((item, index) => (
                                                    <li className="nav-item">
                                                        <a className={`nav-link fw-semibold ${activeTab === index ? "active text-black" : ""}`} key={index} onClick={() => setActiveTab(index)}>
                                                            {item.locationFrom} ➝ {item.locationTo} <span className="align-middle rounded-pill ms-1">{item.dcFlightLegs.length} flights</span>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive table-card mb-1">
                                        <table className="table table-nowrap align-middle" id="orderTable">
                                            <thead className="text-muted table-light">
                                                <tr className="text-uppercase text-center">
                                                    <th>Airline</th>
                                                    <th>Departure</th>
                                                    <th>Duration</th>
                                                    <th>Arrival</th>
                                                    <th>Fares</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {applyFilters(flightData.length > 0 && flightData[activeTab]?.dcFlightLegs || [])?.map((flightLeg, idx) => {
                                                    return (
                                                        <>
                                                            <tr key={idx} style={{ margin: '10px', padding: '10px' }}>
                                                                <td colSpan={4}>
                                                                    <table className="table-responsive" width={"100%"}>
                                                                        {flightLeg.dcDisplayLegs.length > 0 && flightLeg.dcDisplayLegs.map((flight, idy) =>
                                                                            <tr key={idy} style={{ margin: '10px', padding: '10px' }}>
                                                                                <td>
                                                                                    <span>
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div className="flex-grow-1 text-center">
                                                                                                <div className="d-flex justify-content-center">
                                                                                                    <img src={"/assets/images/airlinelogos/" + flight?.airlineData?.airlineCode + ".png"} alt={flight?.airlineData?.airlineCode} width="30px" height="30px" className="img-fluid d-block rounded-2" />
                                                                                                </div>
                                                                                                <h6 className="text-dark pt-1">{flight?.airlineData?.flightNumber}</h6>
                                                                                                <p className="text-muted mb-0">{flight?.airlineData?.airline}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    <span>
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div className="flex-grow-1 text-center">
                                                                                                <h6 className="text-dark">{flight?.startSegment?.airportCode}</h6>
                                                                                                <p className="text-muted mb-0">{moment(flight?.startSegment?.departureDateTime).format("HH:mm")}</p>
                                                                                                <p className="text-muted mb-0">{moment(flight?.startSegment?.departureDateTime).format("DD MMM YY")}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    <span>
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div className="flex-grow-1 text-center">
                                                                                                <h6 className="text-dark">{getTimeFromMins(flight.totalDuration)}</h6>
                                                                                                <p className="text-primary mb-0"><i class="ri-flight-takeoff-line text-primary"></i>...............................<i class="ri-flight-land-line text-primary"></i></p>
                                                                                                <p className="text-muted mb-0">{flight.stops === 0 ? "Non Stop" : flight.stops == 1 ? "1 Stop" : flight.stops + "Stops"}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    <span>
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div className="flex-grow-1 text-center">
                                                                                                <h6 className="text-dark">{flight?.endSegment?.airportCode}</h6>
                                                                                                <p className="text-muted mb-0">{moment(flight?.endSegment?.arrivalDateTime).format("HH:mm")}</p>
                                                                                                <p className="text-muted mb-0">{moment(flight?.endSegment?.arrivalDateTime).format("DD MMM YY")}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </table>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="flex-grow-1 text-center">
                                                                                <span className="badge bg-success">
                                                                                    {
                                                                                        selectedFares[flightData[activeTab]?.journeyType]?.flightLeg?.supplierLegId === flightLeg.supplierLegId
                                                                                            ? selectedFares[flightData[activeTab]?.journeyType]?.fare?.fareIdentifier
                                                                                            : (
                                                                                                flightLeg.dcPriceDetails.reduce((min, curr) =>
                                                                                                    (curr.totalPrice ?? Infinity) < (min.totalPrice ?? Infinity) ? curr : min
                                                                                                )?.fareIdentifier
                                                                                            )

                                                                                    }
                                                                                </span>
                                                                                <p><strong>{currency}
                                                                                    {
                                                                                        selectedFares[flightData[activeTab]?.journeyType]?.flightLeg?.supplierLegId === flightLeg.supplierLegId
                                                                                            ? selectedFares[flightData[activeTab]?.journeyType]?.fare?.totalPrice
                                                                                            : Math.min(...flightLeg.dcPriceDetails.map(fare => fare.totalPrice || Infinity))

                                                                                    }</strong></p>
                                                                                <button
                                                                                    className='btn btn-sm btn-warning text-black'
                                                                                    onClick={() => handleToggleFares(flightLeg.supplierLegId)}
                                                                                >
                                                                                    {expandedFlights[flightLeg.supplierLegId] ? 'Hide Fares' : 'View Fares'}
                                                                                </button>

                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="flex-grow-1 text-center">
                                                                                {
                                                                                    selectedFares[flightData[activeTab]?.journeyType]?.flightLeg?.supplierLegId === flightLeg.supplierLegId ? (
                                                                                        <button className="btn btn-sm btn-success" disabled>SELECTED</button>
                                                                                    ) : (
                                                                                        <button className="btn btn-sm btn-secondary" onClick={() => handleSelectFare(
                                                                                            flightData[activeTab]?.journeyType,
                                                                                            flightLeg,
                                                                                            flightLeg.dcPriceDetails.reduce((min, curr) =>
                                                                                                (curr.totalPrice ?? Infinity) < (min.totalPrice ?? Infinity) ? curr : min
                                                                                            )?.supplierPriceId
                                                                                        )}>SELECT</button>
                                                                                    )
                                                                                }
                                                                                <p className="text-muted mt-2"><Link data-bs-toggle="modal" data-bs-target={"#flight" + flightLeg.supplierLegId}>Flight Details</Link></p>
                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            {expandedFlights[flightLeg.supplierLegId] && (
                                                                <tr>
                                                                    <td colSpan={6}>
                                                                        {flightLeg.dcPriceDetails.map((fare, i) => (
                                                                            <div
                                                                                key={i}
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    padding: '10px 0',
                                                                                    borderBottom: '1px solid #eee',
                                                                                    fontSize: '14px',
                                                                                    gap: '12px',
                                                                                }}
                                                                            >
                                                                                {/* Radio Button */}
                                                                                <input
                                                                                    type="radio"
                                                                                    name={`fare-${flightData[activeTab]?.journeyType}`} // group by journeyType
                                                                                    checked={
                                                                                        selectedFares[flightData[activeTab]?.journeyType]?.fare?.supplierPriceId === fare.supplierPriceId
                                                                                    }
                                                                                    onChange={() => handleSelectFare(flightData[activeTab]?.journeyType, flightLeg, fare.supplierPriceId)}
                                                                                />


                                                                                {/* Price */}
                                                                                <div style={{ width: '100px', fontWeight: 'bold' }}>
                                                                                    INR {fare.totalPrice}
                                                                                </div>

                                                                                {/* Fare Identifier */}
                                                                                <div style={{ width: '120px' }}>
                                                                                    <span className="badge bg-success">{fare.fareIdentifier}</span>
                                                                                </div>

                                                                                {/* Refundable */}
                                                                                <div style={{ width: '140px' }}>
                                                                                    {fare.dcAdults?.refundable === 'Refundable' ? (
                                                                                        <span className="badge bg-primary">REFUNDABLE</span>
                                                                                    ) : (
                                                                                        <span className="badge bg-danger">NON REFUNDABLE</span>
                                                                                    )}
                                                                                </div>

                                                                                {/* Meal Type */}
                                                                                <div style={{ width: '120px' }}>
                                                                                    {fare.dcAdults?.mealType === 'Free Meal' ? (
                                                                                        <span className="badge bg-secondary">FREE MEAL</span>
                                                                                    ) : (
                                                                                        <span className="badge bg-danger">PAID MEAL</span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            )}

                                                            <div id={"flight" + flightLeg.supplierLegId} className="modal fade" role="dialog" aria-hidden="true">
                                                                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                                                    <div className="modal-content">
                                                                        <div className="modal-header">
                                                                            <h5 className="modal-title">Flight Details</h5>
                                                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                                        </div>
                                                                        <div className="modal-body">
                                                                            <div className="flight-details">
                                                                                <div className="row align-items-center trip-title mb-3">
                                                                                    <div className="col col-sm-auto text-center text-sm-start">
                                                                                        <span className="m-0 fs-14">{flightLeg.dcDisplayLegs?.[0]?.startSegment?.city}</span>
                                                                                    </div>
                                                                                    <div className="col-auto text-10 text-black-50 text-center trip-arrow">➝</div>
                                                                                    <div className="col col-sm-auto text-center text-sm-start">
                                                                                        <span className="m-0 fs-14">{flightLeg.dcDisplayLegs?.[0]?.endSegment?.city}</span>
                                                                                    </div>
                                                                                    <div className="col col-sm-auto text-center text-sm-start">
                                                                                        <span className="m-0 fs-14">Departure : {moment(flightLeg.dcDisplayLegs?.[0]?.startSegment?.departureDateTime).format("Do MMM YY HH:mm")}</span>
                                                                                    </div>
                                                                                    <div className="col col-sm-auto text-center text-sm-start">
                                                                                        <span className="m-0 fs-14">Arrival : {moment(flightLeg.dcDisplayLegs?.[0]?.endSegment?.arrivalDateTime).format("Do MMM YY HH:mm")}</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="tab-content my-3">
                                                                                    {flightLeg.dcSegments.length > 0 && flightLeg.dcSegments.map(seg =>
                                                                                        <>
                                                                                            <div className="row flex-row pt-4 px-md-4">
                                                                                                <div className="col-12 col-sm-3 text-center d-lg-flex company-info"> <span className="align-middle"><img className="img-fluid" alt src={"/assets/images/airlinelogos/" + seg?.tFAirlineData?.airlineCode + ".png"} /> </span> <span className="align-middle ms-lg-2"> <span className="d-block text-1 text-dark">{seg.tFAirlineData?.airline}</span> <small className="text-muted d-block">{seg.tFAirlineData?.equimentType + "-" + seg.tFAirlineData?.flightNumber}</small> </span> </div>
                                                                                                <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-5 text-dark">{moment(seg.tFDepartureData.departureDateTime).format('HH:mm')}</span> <small className="text-muted d-block">{seg.tFDepartureData.airportName}, {seg.tFDepartureData.city}, {seg.tFDepartureData.terminal}</small> </div>
                                                                                                <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-3 text-dark">{getTimeFromMins(seg?.tFAirlineData?.duration)}</span> <small className="text-muted d-block">Duration</small> </div>
                                                                                                <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0"> <span className="text-5 text-dark">{moment(seg.tFArrivalData.arrivalDateTime).format('HH:mm')}</span> <small className="text-muted d-block">{seg.tFArrivalData.airportName}, {seg.tFArrivalData.city},{seg.tFArrivalData.terminal}</small> </div>
                                                                                            </div>
                                                                                            {seg?.tFAirlineData?.connectingTime !== 0 ?
                                                                                                <div className="row flex-row pt-4 px-md-4">
                                                                                                    <div className="col-12 col-sm-3 text-center d-lg-flex company-info">
                                                                                                        <span className="badge bg-success">CONNECTING TIME : {getTimeFromMins(seg?.tFAirlineData?.connectingTime)}</span>
                                                                                                    </div>
                                                                                                </div> : ''}
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>}
                </div>
                {/* end col */}
            </div>
            {pageLoading === false ? (
                Object.keys(selectedFares).length > 0 ? (
                    <div className="round-trip-fare fixed-bottom bg-dark shadow-md text-light" style={{ backgroundColor: DefaultData?.THEMECOLOR1 }}>
                        <div className="container p-2 p-sm-4">
                            <div className="row align-items-center">
                                <div className="col-9">
                                    <div className="row">
                                        {Object.entries(selectedFares).map(([journeyType, sf]) => (
                                            <div key={journeyType} className={"border-right border-dark" + Object.keys(selectedFares).length > 1 ? "col-sm-6" : "col-sm-12"}>
                                                <div className="row align-items-center flex-row">
                                                    <div className="col col-sm-4 col-md-3 text-center d-lg-flex company-info">
                                                        <span className="align-middle d-none d-sm-block">
                                                            <img className="img-fluid me-2" alt width={"30px"} height={"30px"} src={`/assets/images/airlinelogos/${sf.flightLeg?.dcDisplayLegs[0]?.airlineData?.airlineCode}.png`} />
                                                        </span>
                                                        <span className="align-middle ml-lg-2">
                                                            <span className="d-block text-1">{sf.flightLeg?.dcDisplayLegs[0]?.airlineData?.airline}</span>
                                                            <small className="text-white-50 d-block">{sf.flightLeg?.dcDisplayLegs[0]?.airlineData?.airlineCode}-{sf.flightLeg?.dcDisplayLegs[0]?.airlineData?.flightNumber}</small>
                                                        </span>
                                                    </div>
                                                    <div className="col col-sm-4 col-md-3 text-center time-info">
                                                        <span className="text-4">{new Date(sf.flightLeg?.dcDisplayLegs[0]?.startSegment?.departureDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                                        <small className="text-white-50 d-none d-lg-block">{sf.flightLeg?.dcDisplayLegs[0]?.startSegment?.city}</small>
                                                    </div>
                                                    <div className="col col-sm-4 col-md-3 text-center time-info">
                                                        <span className="text-4">{new Date(sf.flightLeg?.dcDisplayLegs[0]?.endSegment?.arrivalDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                                        <small className="text-white-50 d-none d-lg-block">{sf.flightLeg?.dcDisplayLegs[0]?.endSegment?.city}</small>
                                                    </div>
                                                    <div className="col-md-3 text-center d-none d-md-block time-info">
                                                        <span className="text-1">{Math.floor(sf.flightLeg?.dcDisplayLegs[0]?.totalDuration / 60)}h {sf.flightLeg?.dcDisplayLegs[0]?.totalDuration % 60}m</span>
                                                        <small className="text-white-50 d-block">Non Stop</small>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="row align-items-center">
                                        <div className="col-12 col-md-6 text-light text-center text-6 price">
                                            <span className="text-1 text-white-50 d-none d-lg-block">Total Fare: </span>
                                            {currency} {Object.values(selectedFares).reduce((sum, sf) => sum + (sf.fare?.totalPrice || 0), 0).toFixed(2)}
                                        </div>
                                        <div className="col-12 col-md-6 text-center mt-2 mt-md-0 btn-book">
                                            <button onClick={handleSubmit}
                                                className="btn btn-sm btn-primary px-sm-2 px-lg-3"
                                            >
                                                <i className="fas fa-shopping-cart d-block d-lg-none" />
                                                <span className="d-none d-lg-block">Book Now</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : "") : ""}
        </>
    );
};

export default Flights;
